module.exports = __webpack_public_path__ + "img/Preise_ab_01.04.20.f5418fe5.jpg";